import { useMediaQuery } from '@/hooks/useMediaQuery.hook';
import { useMemo, useState } from 'react';
import { SEARCH_PLACEHOLDER } from '../_const';
import { SearchMode } from '../_types';

/**
 * 검색 모드(Genes/Panel) 관리를 위한 커스텀 훅
 *
 * 주요 기능:
 * 1. 검색 모드 상태 관리 (Genes/Panel)
 * 2. 미디어쿼리를 사용해 화면 크기에 따른 적절한 placeholder 제공
 *
 * @returns {Object} 검색 모드 관련 상태와 함수
 */
export function useSearchMode(initialMode: SearchMode = 'Genes') {
  const [searchMode, setSearchMode] = useState<SearchMode>(initialMode);
  // 뒤로/앞으로 가기처럼 컴포넌트가 유지된 채 URL만 바뀌는(soft nav) 경우,
  // useState 초기값은 이미 지나갔으므로 URL 모드에 로컬 모드를 맞춰 재동기화한다.
  const [prevInitialMode, setPrevInitialMode] = useState(initialMode);
  if (initialMode !== prevInitialMode) {
    setPrevInitialMode(initialMode);
    setSearchMode(initialMode);
  }

  const isMobile = useMediaQuery('(max-width: 768px)');

  // 화면 크기에 따라 적절한 placeholder 계산 (useMemo로 최적화)
  const placeholder = useMemo(() => {
    return isMobile
      ? SEARCH_PLACEHOLDER[searchMode].mobile
      : SEARCH_PLACEHOLDER[searchMode].default;
  }, [isMobile, searchMode]);

  return {
    searchMode,
    setSearchMode,
    placeholder,
  };
}
